import { useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { selectCountry, selectSizeC, selectPayment, selectDelivery } from '@store/order/selectors';
import { useLazyGetPriceWithCountryQuery } from '@api/baseApi';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import Letter from '@pages/order/summary/footer/Letter';
import SaveButton from '@pages/order/summary/footer/SaveButton';
import SaveButtonCat from '@pages/order/summary/footer/SaveButtonCat';
import { CountryEnum } from '@api/types/CountryEnum';
import { renderPrice } from '@components/utils';



interface FooterProps {
	animalType: AnimalTypeEnum,
}


const Footer = (props: FooterProps): JSX.Element => {
	const { animalType } = props;
	
	const country = useSelector(selectCountry);
	const sizeC = useSelector(selectSizeC);
	const payment = useSelector(selectPayment);
	const delivery = useSelector(selectDelivery);

	const [ getPrice, { data, isLoading, isFetching, isError, isSuccess } ] = useLazyGetPriceWithCountryQuery();

	const priceString = `${
			data && data.priceWithVat > 0 ? renderPrice(data.priceWithVat) : '0'
		}\u00a0${
			country === CountryEnum.sk ? '\u20AC' : 'Kč'
		}`;

	const priceStringNoVat = `${
			data && data.priceNoVat > 0 ? renderPrice(data.priceNoVat) : '0'
		}\u00a0${
			country === CountryEnum.sk ? '\u20AC' : 'Kč'
		}`;


	useEffect(() => {
		if (sizeC !== null && sizeC > 0) {
			getPrice({
				size: sizeC,
				animalType: animalType,
				paymentType: payment ? payment.id : undefined,
				deliveryType: delivery ? delivery.id : undefined,
				country: country
			});
		}
	}, [ sizeC, payment, delivery, country ]);


	return (
		<>
			<Letter price={data} country={country} />			
			<div className='order-summary-element footer-element'>
				<p className='gdpr-message'>Jedná se o&nbsp;závaznou objednávku s&nbsp;povinností platby</p>

				{!sizeC &&
					<p className='info-message'>Cena: Pro&nbsp;výpočet ceny zadejte všechny rozměry</p>}

				{isError &&
					<p className='error-message'>Chyba při výpočtu ceny</p>}

				{(isLoading || isFetching) &&
					<p className='loading-message'>Cena: Počítám cenu...</p>}

				{isSuccess && data !== undefined && data !== null &&
					<p>{`Cena: ${priceString}`}<br/>
					{`(${priceStringNoVat} bez\u00a0DPH)`}
					</p>}

				{animalType === AnimalTypeEnum.dog ? <SaveButton price={data} /> : <SaveButtonCat price={data} />}
			</div>
		</>
	);
};

export default memo(Footer);